<div class="tile">
  <div class="header">
    <h4 class="company-name">{{ authStore.companyName$ | async }}</h4>
    <div class="badge">
      <app-booking-package-badge
        [packageType]="subscription.plan"
        size="small"
      ></app-booking-package-badge>
    </div>
  </div>
  <p class="row-data" *ngIf="authStore.companyAddressAsString$ | async as address">{{ address }}</p>
  <p class="row-data">
    {{ dateLabel | translate }}
    {{ subscription.expirationDate | date }}
  </p>
  <p class="row-data">
    {{ '+BOOKING.OVERVIEW.FLATRATE.BOOKING_FROM' | translate }}
    {{ subscription.subscribedByName }}
  </p>
  <button
    *ngIf="isActiveSubscription; else renewButton"
    class="tile-button"
    mat-stroked-button
    gtm="onOpen"
    gtmaction="Cancel flat rate subscription confirmation modal"
    gtmcategory="bookingOverview"
    [disabled]="subscription.status?.toLowerCase() === subscriptionStatus.canceled"
    appCancelBooking
    [companyId]="authStore.getCompanyId() | async"
    [isFlatRate]="true"
    [subscriptionPlan]="subscription.plan"
  >
    {{ '+BOOKING.OVERVIEW.FLATRATE.CANCEL_SUBSCRIPTION' | translate }}
  </button>
  <ng-template #renewButton>
    <button
      class="tile-button"
      mat-raised-button
      color="primary"
      gtm="onOpen"
      gtmaction="Renew flat rate subscription"
      gtmcategory="bookingOverview"
      (click)="onRenewSubscription()"
      [disabled]="isAnyActiveOrCancelledSubscription"
    >
      {{ '+BOOKING.OVERVIEW.FLATRATE.RENEW_SUBSCRIPTION' | translate }}
    </button>
  </ng-template>
</div>
